<template>
    <div class="premium-container">
      <dataTop></dataTop>
        <div class="title">
            <span>{{name}}-成交溢价情况</span>
        </div>
        <div class="container flex-x">
            <aside-info></aside-info>
            <list-info></list-info>
        </div>
    </div>
</template>
<script>
import asideInfo from './asideInfo.vue'
import listInfo from './listInfo.vue'
import dataTop from "../index/components/dataTop";
export default {
    name:'premium',
    data(){
        return{
          name:'',
        }
    },
    components:{
        asideInfo,
        listInfo,
      dataTop,
    },
    methods: {
      back() {
        this.$router.go(-1)
      },
      refresh() {
        window.location.reload();
      }
    },
    created(){
      this.name = this.$route.query.companyName;

    }
  }
</script>
<style lang="scss" scoped>
  .flex-x {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .flex-y {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .pointer {
    cursor: pointer;
  }

  .premium-container {
    padding: 0 15px 15px;
    background-color: #061033;
    min-height: 100vh;
    width: 100%;

    .top {
      padding: 0 19px;
      color: #B8D7FF;
      font-size: 16px;
      position: relative;
      height: 66px;

      .name {
        // position: absolute;
        // top: 0;
        // left: 50%;
        // margin-left: -254px;
        // font-size: 28px;
        // font-weight: 600;
        // color: #fff;
        width: 509px;
        height: 66px;
        background: url('/img/bigdata/big-data-top-1366.png') no-repeat left top;

      }

      .notice {
        span {
          display: inline-block;
          width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .refresh {
        margin-left: 16px;

      }
    }

    .title {
      margin-left: 34px;
      margin-bottom: 30px;
      margin-top:20px;
      span {
        font-size: 24px;
        color: #fff;
      }
    }

    .container {
      padding: 0 38px;
      align-items: flex-start;


    }
  }
</style>


